function bufToHex(buf: ArrayBuffer) {
  return Array.from(new Uint8Array(buf))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

async function sha256Hex(input: string) {
  const enc = new TextEncoder();
  const digest = await crypto.subtle.digest('SHA-256', enc.encode(input));
  return bufToHex(digest);
}

function collectFingerprintEntropy() {
  const nav = window.navigator as any;
  const scr = window.screen;

  // Keep this stable-ish; avoid super unique values that change frequently.
  return {
    ua: navigator.userAgent,
    lang: navigator.language,
    langs: Array.isArray(nav.languages) ? nav.languages.join(',') : '',
    platform: nav.platform || '',
    vendor: nav.vendor || '',
    tz: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
    hw: nav.hardwareConcurrency || 0,
    mem: nav.deviceMemory || 0,
    scr: `${scr?.width || 0}x${scr?.height || 0}x${scr?.colorDepth || 0}`,
    touch: nav.maxTouchPoints || 0,
  };
}

const STORAGE_KEY = 'deviceFingerprint.v1';

export async function getOrCreateDeviceFingerprint(): Promise<string | null> {
  try {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing) return existing;

    // crypto.subtle requires secure context; if not available, fall back to a weaker hash.
    if (!window.crypto?.subtle) return null;

    const entropy = collectFingerprintEntropy();
    const fp = await sha256Hex(JSON.stringify(entropy));
    localStorage.setItem(STORAGE_KEY, fp);
    return fp;
  } catch {
    return null;
  }
}

